/**
 * Impresa - SPECIFICHE 2.3
 *
 * Anagrafica imprese, una riga per impresa per cassa.
 * La stessa impresa può esistere in entrambe le casse con codici diversi.
 */
import { z } from 'zod';
import { CassaCodeSchema, str, dateStr } from './common.ts';

export const OrigineImpresaSchema = z.enum(['CASSA', 'MANUALE']);
export type OrigineImpresa = z.infer<typeof OrigineImpresaSchema>;

export const ImpresaSchema = z.object({
  id: z.number(),
  cassa: CassaCodeSchema.nullable(), // null per imprese MANUALE (migration 0006)
  codImp: z.string(), // generato dall'app per le manuali (es. MAN-<id>)
  ragioneSociale: str, // required ma il DB lo accetta nullable; vincolo applicativo
  partitaIva: str, // alternativo a CF/ragioneSociale
  codiceFiscale: str,
  indirizzo: str,
  cap: str,
  citta: str,
  provincia: str,
  telefono: str,
  cellulare: str,
  fax: str,
  email: str,
  dataIscrizione: dateStr,
  dataCessazione: dateStr,
  ccnl: str,
  codiceConsorzio: str,
  codicePagamento: str,
  ac: str,
  albo: str,
  numOperai: str,
  dataSospensione: dateStr,
  tipoServizio: str,
  codce: str, // Codice impresa cassa
  origine: OrigineImpresaSchema, // CASSA = da caricamento mensile; MANUALE = inserita a mano
  createdAt: str,
  updatedAt: str,
});

export type Impresa = z.infer<typeof ImpresaSchema>;

// Per INSERT (senza id e timestamp). `origine` opzionale: default 'CASSA' lato DB.
export type ImpresaInsert = Omit<Impresa, 'id' | 'createdAt' | 'updatedAt' | 'origine'> & {
  origine?: OrigineImpresa;
};

// Payload per inserimento manuale: cassa/codImp/origine sono valorizzati dal repo.
export type ImpresaManualeInsert = Omit<ImpresaInsert, 'cassa' | 'codImp' | 'origine'>;
